import * as React from 'react'
import { BaseIconProps } from '../../types'

function SvgStar({ size = '24', color = '#666', ...props }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.628 21.31a1.677 1.677 0 01-2.254-.694 1.64 1.64 0 01-.168-1.05l.835-4.82-3.537-3.414a1.642 1.642 0 01-.03-2.338c.256-.26.592-.43.955-.482l4.888-.704 2.186-4.386a1.677 1.677 0 012.994 0l2.186 4.386 4.887.704c.913.13 1.545.97 1.412 1.873-.052.36-.223.693-.486.947l-3.537 3.414.835 4.82c.156.9-.455 1.756-1.363 1.91a1.684 1.684 0 01-1.06-.166L12 19.034 7.628 21.31zm3.595-4.362a1.683 1.683 0 011.554 0l3.632 1.89-.693-4.005a1.643 1.643 0 01.48-1.463l2.938-2.837-4.06-.585a1.668 1.668 0 01-1.258-.904L12 5.399l-1.816 3.645a1.668 1.668 0 01-1.257.904l-4.062.585 2.94 2.837c.393.38.572.927.48 1.463l-.695 4.006 3.633-1.891z"
        fill={color}
      />
    </svg>
  )
}

export default SvgStar
